// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"570":"37788ca1","3583":"1cb633a4","4992":"37788ca1","7248":"1cb633a4"}[chunkId] + ".chunk.css";
};